import apiClient from './client';

export const IcdNotAllowedPrincipalDiagnosisAxiosInstance = apiClient;